export const E_TOOLS_HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 72,
};

export const E_TOOLS_NAV = {
  WIDTH: 220,
};
